import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Header, Footer, Page } from "@/components/Shell";

export default function PaymentCancelled() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  return (
    <Page tone="ivory">
      <Header variant="ivory" />
      <section className="max-w-3xl mx-auto px-6 md:px-10 pt-20 pb-24" data-testid="payment-cancelled-page">
        <div className="overline mb-6">Paiement interrompu</div>
        <h1 className="font-display text-[38px] md:text-[48px] leading-tight text-ink">
          Le paiement a été annulé.
        </h1>
        <div className="mt-10 border border-[color:var(--border-bronze)] bg-stone rounded-sm p-8">
          <p className="text-[16px] text-text-2 leading-relaxed">
            Aucun montant n'a été prélevé. Vos réponses sont conservées et vous pouvez reprendre le paiement quand vous êtes prêt.
          </p>
          <p className="mt-4 text-[13px] text-text-2/80">
            Si vous souhaitez en discuter avant de poursuivre, écrivez à
            <a className="underline mx-1 text-bronze-dark hover:text-ink" href="mailto:direction@maisonbeaudette.com">direction@maisonbeaudette.com</a>.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            {token ? (
              <Link to={`/paiement/${token}`} className="btn-primary" data-testid="btn-resume-payment">
                Reprendre le paiement
              </Link>
            ) : (
              <Link to="/commencer" className="btn-primary" data-testid="btn-restart">
                Reprendre le parcours
              </Link>
            )}
            <Link to="/retrouver" className="btn-ghost" data-testid="btn-retrieve">
              Retrouver ma lecture
            </Link>
          </div>
        </div>
        <p className="mt-8 text-[12px] tracking-[0.26em] uppercase text-text-2">
          Paiement sécurisé · Aucun prélèvement · Confidentialité assurée
        </p>
      </section>
      <Footer />
    </Page>
  );
}
